export const TRANSITION_PRODUCT_VIEW_BEFORE = "product-view-before";
export const TRANSITION_PRODUCT_VIEW_LEAVE = "product-view-leave";
export const TRANSITION_PRODUCT_VIEW_ENTER = "product-view-enter";
export const TRANSITION_PRODUCT_VIEW_AFTER = "product-view-after";
export const TRANSITION_PRODUCT_VIEW_AFTER_ENTER = "product-view-after-enter";
